import React from 'react'
import styled from 'styled-components'
const Footer = () => {
  return (
    <Wrapper>
      <h5>
        &copy; {new Date().getFullYear()}
        <span>@bazzodecor</span>
      </h5>
      <h5></h5>
      <div class="wc_whatsapp_app right">
    <a href="https://wa.me/5515996709462" target="_blank" class="wc_whatsapp" >
        <span class="wc_whatsapp_primary">
            <span class="close"></span>
            <img src="https://image.flaticon.com/icons/png/512/124/124034.png" width="70" height="70"/>
        </span>
    </a>
    <a href="https://wa.me/5515996709462" target="_blank" class="wc_whatsapp_secondary" >
    </a>
</div>
    </Wrapper>
  )
}

const Wrapper = styled.footer`
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--clr-black);
  text-align: center;
  span {
    color: var(--clr-primary-5);
  }
  h5 {
    color: var(--clr-white);
    margin: 0.1rem;

    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
  }
  @media (min-width: 776px) {
    flex-direction: row;
  }
`

export default Footer
